<template>
  <div>
    <div class="d-flex flex-wrap flex-gap-16">
      <ImageCard v-for="image of images" :images="images" :file="image" :key="image.id" :isEdited="isEdited" @onRemove="onRemove" />
      <!--      <VideoCard v-for="video of videos" :file="video" :key="video.id" :isEdited="false" @onRemove="onRemove" />-->
    </div>
    <div v-if="otherFiles.length" class="d-flex flex-column flex-gap-10 mt-4">
      <FileCard v-for="file of otherFiles" :file="file" :key="file.id" :isEdited="isEdited" @onRemove="onRemove" />
    </div>
  </div>
</template>

<script>
import ImageCard from '@/components/ui/ImageCard';
import FileCard from '@/components/ui/FileCard';

const imageRegex = /\.(jpg|jpeg|png|gif|webp|heic|heiff|jfif)\b/i;
const videoRegex = /\.(jpg|jpeg|png|gif)\b/;

export default {
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    isEdited: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ImageCard,
    // VideoCard,
    FileCard,
  },
  computed: {
    images() {
      return this.files.filter((file) => !!file.fileName.match(imageRegex));
    },
    videos() {
      return this.files.filter((file) => !!file.fileName.match(videoRegex));
    },
    otherFiles() {
      return this.files.filter((file) => !file.fileName.match(imageRegex)/* && !file.fileName.match(imageRegex) */);
    },
  },
  methods: {
    onRemove(file) {
      this.$emit('onRemove', file);
    },
  },
};
</script>
